import styled from "styled-components";
import "../../style/site.styl";
import { Button } from "react-bootstrap";

export const LargeButton = styled(Button)`
height: 30px;
width: 20rem !important;
margin: 5px 0;
padding: 4px 14px;
background-color: #3067bd;
border-color: #3067bd;
color: #fff;
font: 14px 'Arial';
`;
export const SmallButton = styled(Button)`
height: 30px;
width: 10rem !important;
margin: 5px 0;
padding: 4px 14px;
background-color: #3067bd;
border-color: #3067bd;
color: #fff;
font: 14px 'Arial';
`;

